(function () {
  var GRID = '#product-grid';
  var PAGINATION = '.pagination-wrapper';
  var loading = false;
  var observer = null;
  var currentPage = 1;

  function pageFromUrl(url) {
    var m = url.match(/[?&]page=(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }

  function findNext(pagination) {
    var want = currentPage + 1;
    var links = pagination.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      if (pageFromUrl(links[i].getAttribute('href')) === want) return links[i];
    }
    return null;
  }

  function cleanItem(li) {
    li.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
    li.style.removeProperty('--animation-order');
    return li;
  }

  function loadNext(pagination) {
    var next = findNext(pagination);
    if (!next || loading) return;
    loading = true;
    fetch(next.href)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.querySelector(GRID);
        doc.querySelectorAll(GRID + ' > li').forEach(function (li) {
          grid.appendChild(cleanItem(li));
        });
        currentPage += 1;
        var newPag = doc.querySelector(PAGINATION);
        if (newPag && findNext(newPag)) {
          pagination.replaceWith(newPag);
          observe(newPag);
        } else {
          pagination.remove();
        }
      })
      .catch(function (e) { console.error('Infinite scroll:', e); })
      .finally(function () { loading = false; });
  }

  function observe(pagination) {
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) loadNext(pagination);
    }, { rootMargin: '600px 0px' });
    observer.observe(pagination);
  }

  function init() {
    currentPage = pageFromUrl(location.search);
    var pagination = document.querySelector(PAGINATION);
    if (pagination && document.querySelector(GRID)) observe(pagination);
  }

  init();
  var container = document.getElementById('ProductGridContainer');
  if (container) new MutationObserver(init).observe(container, { childList: true });
})();